import {
  FETCH_DASHBOARD_DATA_REQUEST,
  FETCH_DASHBOARD_DATA_SUCCESS,
  FETCH_DASHBOARD_DATA_FAILURE,
  FETCH_OEM_PARTNERS_REQUEST,
  FETCH_OEM_PARTNERS_SUCCESS,
  FETCH_OEM_PARTNERS_FAILURE,
  SET_SELECTED_OEM_ID,
  CLEAR_DASHBOARD_DATA,
  CLEAR_DASHBOARD_ERROR
} from '../constants/dashboardConstants';

const initialState = {
  loading: false,
  error: null,
  dashboardData: {
    oemPartners: 0,
    oemUsers: 0,
    totalScans: 0,
    revenueUSD: 0,
    revenueJPY: 0,
    scanAnalytics: {
      totalScans: 0,
      completed: 0,
      pending: 0,
      failed: 0,
      successRate: 0
    },
    recentScans: [],
    topRevenuePartners: [],
    globalDistribution: []
  },
  oemPartners: [],
  selectedOemId: '',
  filtersLoading: false
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DASHBOARD_DATA_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_DASHBOARD_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        dashboardData: action.payload
      };
    case FETCH_DASHBOARD_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case FETCH_OEM_PARTNERS_REQUEST:
      return {
        ...state,
        filtersLoading: true
      };
    case FETCH_OEM_PARTNERS_SUCCESS:
      return {
        ...state,
        filtersLoading: false,
        oemPartners: action.payload
      };
    case FETCH_OEM_PARTNERS_FAILURE:
      return {
        ...state,
        filtersLoading: false,
        error: action.payload
      };
    case SET_SELECTED_OEM_ID:
      return {
        ...state,
        selectedOemId: action.payload
      };
    case CLEAR_DASHBOARD_DATA:
      return {
        ...state,
        dashboardData: initialState.dashboardData
      };
    case CLEAR_DASHBOARD_ERROR:
      return {
        ...state,
        error: null
      };
    default:
      return state;
  }
};

export default dashboardReducer;